import { render, staticRenderFns } from "./VerticalCollapseRenderer.vue?vue&type=template&id=586c5bca&"
import script from "./VerticalCollapseRenderer.vue?vue&type=script&lang=js&"
export * from "./VerticalCollapseRenderer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports